<template>
  <v-card class="mb-4 hvh-card--rounded hvh-analysis-segments">
    <CardTitle :title="title + (allChildrenSelected ? '' : ' *')" :class="{ 'pb-0': !isCollapsed }" v-model="isCollapsed" />
    <div ref="items" class="hvh-items hvh-categories hvh-height-400" v-show="!isCollapsed">
      <v-card-text class="pt-0">
        <InputCheckbox class="mt-1 hvh-strong" :value="allSelected" :color="color" text="Select all" @input="selectAll" />
        <div v-for="category in items" :key="category.label" class="hvh-analysis-segments__checkbox--lvl2">
          <AnalysisLegendCategory :category="category" @change="emitChange" />
        </div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import AnalysisLegendCategory from './HvhAnalysisLegendCategory.vue';
import CardTitle from '../common/cardTitle/HvhCardTitle.vue';
import InputCheckbox from '../common/form/inputCheckbox/HvhInputCheckbox';

export default {
  components: {
    AnalysisLegendCategory,
    CardTitle,
    InputCheckbox,
  },
  props: ['title', 'items'],
  data() {
    return {
      showMenu: false,
      showAllItems: false,
      isCollapsed: false,
    };
  },
  methods: {
    emitChange() {
      this.$emit('change', this.allChildren.filter(f => f.checked));
    },
    selectAll() {
      var shouldSelect = !this.allChildrenSelected;
      this.allChildren.forEach(f => f.checked = shouldSelect);
      this.emitChange();
    },
  },
  computed: {
    allChildrenSelected() {
      return this.allChildren.find(f => !f.checked) == null;
    },
    allSelected() {
      return this.allChildren.find(f => f.checked) != null;
    },
    color() {
      return this.allChildren.find(f => !f.checked) == null ? '#11697d' : 'grey';
    },
    allChildren() {
      return this.items.flatMap((f) => f.children);
    },
  },
};
</script>

<style lang="scss">
.hvh-strong {
  font-weight: bolder;
}

.hvh-soft {
  font-style: italic;
}

.hvh-height-400 {
  height: 400px;
}
</style>
